import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

// For some reason, Meta returns Instagram's query params prefixed with a hash (#) instead of a question mark (?)
// causing the query params to be ignored. This hook is a workaround to extract the query params
export const useOauthQueryParams = () => {
  const { hash, search } = useLocation()

  const queryParams = useMemo(() => {
    const searchParams = new URLSearchParams(search)
    const hashParams = new URLSearchParams(hash)

    const params = new URLSearchParams()

    for (const [key, value] of searchParams) {
      params.set(key, value)
    }

    for (const [key, value] of hashParams) {
      params.set(key, value)
    }

    return Object.fromEntries(params)
  }, [hash, search])

  return queryParams
}
